import React from "react";
import { IconButton, alpha, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

/**
 * ScrollArrows Component
 * Navigation arrows for carousel scrolling
 */
const ScrollArrows = ({ onScrollLeft, onScrollRight }) => {
  const theme = useTheme();

  const arrowStyles = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    bgcolor: "background.paper",
    boxShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.15)}`,
    "&:hover": {
      bgcolor: "background.paper",
      boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.2)}`,
    },
    width: 32,
    height: 32,
  };

  return (
    <>
      {/* Left Arrow */}
      <IconButton onClick={onScrollLeft} sx={{ ...arrowStyles, left: -8 }}>
        <ChevronLeft fontSize="small" />
      </IconButton>

      {/* Right Arrow */}
      <IconButton onClick={onScrollRight} sx={{ ...arrowStyles, right: -8 }}>
        <ChevronRight fontSize="small" />
      </IconButton>
    </>
  );
};

export default ScrollArrows;
